// extracted by mini-css-extract-plugin
export default {"searchDiv":"styles_searchDiv__xsZEv","mob":"styles_mob__kFvD7"};